import "./OpenSourceCard.css";

import { Fade } from "react-reveal";
import { Icon } from "@iconify/react";
import React from "react";

export default function OpenSourceCard({ project, theme }) {
  return (
    <Fade bottom duration={1500} distance="30px">
      <div className="open-source-wrapper">
        <div className="open-source-card">
          <div className="osc-header">
            <h2 style={{ color: theme.text }}>{project.name}</h2>
            <a href={project.url} target="_blank" rel="noopener noreferrer">
              <button
                style={{
                  backgroundColor: theme.accentBright,
                  color: theme.text,
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                View Project
              </button>
            </a>
          </div>

          <p className="osc-description" style={{ color: theme.secondaryText }}>
            {project.description}
          </p>

          <div className="osc-languages">
            {project.languages.map((lang) => (
              <span key={lang.name} className="osc-lang">
                <Icon icon={lang.iconifyClass} width="20" height="20" />
                {lang.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}
